// Zentrale Stelle für „Kontakt öffnen“ (Vorgabe CLAUDE.md / README §9):
// Jeder Klick auf Eigentümer, Mieter oder Dienstleister läuft über openKontakt(id, typ).
// Mieter, Eigentümer und Dienstleister öffnen ihre neue Detailseite (Handoff Mieter M3, Eigentümer E4, Dienstleister E4); die
// übrigen Typen führen auf die bestehende Kontakt-Detailseite. Umgestellt wird NUR kontaktZiel().

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export type KontaktTyp = 'mieter' | 'eigentuemer' | 'dienstleister' | 'kontakt';

/** Ziel-Pfad für einen Kontakt. */
export function kontaktZiel(id: string, typ: KontaktTyp): string {
  if (typ === 'mieter') return `/admin/mieter/${encodeURIComponent(id)}`;
  if (typ === 'eigentuemer') return `/admin/eigentuemer/${encodeURIComponent(id)}`;
  if (typ === 'dienstleister') return `/admin/dienstleister/${encodeURIComponent(id)}`;
  return `/admin/kontakte/${typ}/${encodeURIComponent(id)}`;
}

/** Liefert openKontakt(id, typ) für Komponenten. */
export function useOpenKontakt(): (id: string, typ: KontaktTyp) => void {
  const navigate = useNavigate();
  return useCallback((id: string, typ: KontaktTyp) => navigate(kontaktZiel(id, typ)), [navigate]);
}
